import { useQuery } from 'react-query';

import { getObjectTraps } from 'api/analitics/ObjectTraps/getObjectTraps';

export const useGetObjectTraps = (slug: string, enabled?: boolean) => {
  const { data, refetch, isLoading, isFetching } = useQuery('getObjectTraps', () => getObjectTraps(slug), {
    refetchOnWindowFocus: false,
    enabled,
  });

  return { data, refetch, isLoading, isFetching };
};

export default useGetObjectTraps;
